import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    stepperActionContainer: {
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down("1450")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "12px",
      },
    },
    summaryCard: {
      padding: "20px 32px",
    },
    summaryContainer: {
      display: "flex",
      gap: "40px",
      [theme.breakpoints.down("1170")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "40px",
      },
    },
    summaryContent: {
      display: "flex",
      flexDirection: "column",
      gap: " 15px",
      alignItems: "flex-start",
    },
    propertyContainer: {
      backgroundColor: theme.palette.background.gray_50,
      display: "inline-block",
      minWidth: "290px",
      padding: "16px 24px",
      display: "flex",
      flexDirection: "column",
      gap: " 6px",
    },
    propertyInfo: {
      display: "flex",
      gap: "4px",
    },
    title: {
      color: theme.palette.text.tertiary,
      fontWeight: "500",
      fontSize: "14px",
    },
    referalName: {
      fontSize: "14px",
      fontWeight: "600",
    },
    value: {
      fontSize: "16px",
      fontWeight: "600",
      color: theme.palette.text.secondary,
    },
    isBulk: {
      display: "flex",
      gap: "4px",
    },
    checkIcon: {
      fill: theme.palette.success.main,
    },
    CloseXIcon: {
      fill: theme.palette.foreground.errorSecondary,
    },
    unitDetailsContainer: {
      display: "flex",
      gap: "8px",
    },
    unitsIcon: {
      fill: theme.palette.utility.utility_gray_400,
    },
    schemaProperty: {
      display: "flex",
      gap: "8px",
      flexDirection: "column",
    },
    contentWrapper: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      [theme.breakpoints.down("780")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "40px",
      },
    },
  };
});
